import { createSlice } from "@reduxjs/toolkit";
import { getEditDoctorDetails } from "../../actions/users/usersData";

const initialState = {
  currentUser: null,
  failed: null
};

export const editDoctorsDataSlice = createSlice({
  name: "editdoctor",
  initialState,
  reducers: {
    createNewUser: (state) => {
      state.currentUser = null;
    }
  },
  extraReducers: {
    [getEditDoctorDetails.pending]: () => {},
    [getEditDoctorDetails.fulfilled]: (state, { payload }) => {
      state.currentUser = payload;
    },
    [getEditDoctorDetails.rejected]: (state, { error }) => {
      state.failed = error;
    }
  }
});

export const { editdoctor, createNewUser } = editDoctorsDataSlice.actions;

export default editDoctorsDataSlice.reducer;
